import { render, staticRenderFns } from "./TypicalAchievement.vue?vue&type=template&id=2fb55bf9&scoped=true&"
import script from "./TypicalAchievement.vue?vue&type=script&lang=js&"
export * from "./TypicalAchievement.vue?vue&type=script&lang=js&"
import style0 from "./TypicalAchievement.vue?vue&type=style&index=0&id=2fb55bf9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb55bf9",
  null
  
)

export default component.exports